export function getMoneyFormat(amount : number, currencyCode = 'EUR') {
    return amount.toLocaleString('en-IE', {
        style: 'currency',
        currency: currencyCode
    });
}

export function splitWordOnCamelCase(word: string) {
    return word.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export function getPercentage(decimalInput: number | null) {
    if (decimalInput == null) return;
    var percentage = decimalInput * 100;
    return percentage + '%';
}

export function removeSpaces(value: string) {
    return value.replace(/\s+/g, "");
}

export function removeSpacesTrimAndLower(value: string) {
    var valueWithoutSpaces = value.replace(/\s+/g, "");

    return valueWithoutSpaces.toLowerCase().trim();
}

